var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 55"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".laptop_svg__cls-1{fill:#fff}.laptop_svg__cls-1,.laptop_svg__cls-2,.laptop_svg__cls-3{fill-rule:evenodd}.laptop_svg__cls-2{fill:#010101}.laptop_svg__cls-3{fill:#c08d42}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_svg__Desktop-V5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_svg__PDI-Valuation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_svg__Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9 19.9c0 11-8.9 19.9-19.9 19.9S0 31 0 19.9 8.9 0 19.9 0s19.9 8.9 19.9 19.9",
    fill: "#f8edda",
    fillRule: "evenodd",
    id: "laptop_svg__Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    d: "M57 14H8c-1.1 0-2 .9-2 2v33h53V16c0-1.1-.9-2-2-2",
    id: "laptop_svg__Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M60 49h-2V16c0-.5-.5-1-1-1H8c-.6 0-1 .5-1 1v33H5V16c0-1.6 1.4-3 3-3h49c1.7 0 3 1.4 3 3v33z",
    id: "laptop_svg__Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    d: "M63 49H39l-1 1H26l-1-1H1v2c0 1.7 1.3 3 3 3h56c1.7 0 3-1.3 3-3v-2z",
    id: "laptop_svg__Fill-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop_svg__Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M2 50v1c0 1.1.9 2 2 2h56c1.1 0 2-.9 2-2v-1H39.4l-1 1H25.6l-1-1H2zm58 5H4c-2.2 0-4-1.8-4-4v-3h25.4l1 1h11.2l1-1H64v3c0 2.2-1.8 4-4 4z",
    id: "laptop_svg__Fill-9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-3",
    d: "M16 46h5v-7h-5v7z",
    id: "laptop_svg__Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-3",
    d: "M25 46h5V34h-5v12z",
    id: "laptop_svg__Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-3",
    d: "M34 46h5V23h-5v23z",
    id: "laptop_svg__Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-3",
    d: "M43 46h5V30h-5v16z",
    id: "laptop_svg__Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M22 46h-2v-6h-3v6h-2v-8h7v8z",
    id: "laptop_svg__Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M31 46h-2V35h-3v11h-2V33h7v13z",
    id: "laptop_svg__Fill-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M40 46h-2V24h-3v22h-2V22h7v24z",
    id: "laptop_svg__Fill-19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-2",
    d: "M49 46h-2V31h-3v15h-2V29h7v17z",
    id: "laptop_svg__Fill-20"
  })))))));
}
export default SvgLaptop;